import BrandPortfolioStrategyMixin from "@/mixins/BrandPortfolioStrategyMixin.vue";
export default {
  name: "SpendBar",
  mixins: [BrandPortfolioStrategyMixin],
  props: {
    portfolio: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      fullBarWidth: 280
    };
  },
  components: {},
  methods: {
    fullBarValue(portfolio) {
      const weeklyBudget = this.ppcWeeklyBudget(portfolio);
      return portfolio.ppc_forecast <= weeklyBudget ? weeklyBudget / 0.9 : portfolio.ppc_forecast;
    },
    forecastLength(portfolio) {
      const fullBarValue = this.fullBarValue(portfolio);
      return ` width: ${portfolio.ppc_forecast / fullBarValue * this.fullBarWidth}px`;
    },
    spendLength(portfolio) {
      const fullBarValue = this.fullBarValue(portfolio);
      return ` width: ${portfolio.ppc_spend / fullBarValue * this.fullBarWidth}px`;
    },
    budgetLineDashArray(portfolio) {
      return this.ppcForecastStatus(portfolio) == "ALERT" ? "2 4" : "none";
    }
  }
};